import type { CalculatorProps } from '@/types';
import styles from './calculatorValues.module.scss';

interface CalculatorValuesProps {
  data: CalculatorProps;
  payment: number | string;
}
export const CalculatorValues = ({ data, payment }: CalculatorValuesProps) => {
  const valueStyles = `${styles.value} ${styles[data.variation]}`;
  const descriptionStyles = `${styles.description} ${styles[data.variation]}`;
  return (
    <div className={`${styles.values} ${styles[data.variation]}`}>
      <div
        className={`${styles.wrapper} ${styles.payment} ${styles[data.variation]}`}
      >
        <span className={valueStyles}>${payment}/mo</span>
        <span className={descriptionStyles}>{data.resultText}</span>
      </div>
      <div className={styles.wrapper}>
        <span className={valueStyles}>{data.timeLineValue}</span>
        <span className={descriptionStyles}>{data.timeLineText}</span>
      </div>
      <div className={styles.wrapper}>
        <span className={valueStyles}>{data.rateValue}%</span>
        <span className={descriptionStyles}>{data.rateText}</span>
      </div>
    </div>
  );
};
